import * as cornerstone from "@cornerstonejs/core";
import { ViewportType } from "@cornerstonejs/core/enums";
import { vec3 } from "gl-matrix";
import {
  addToolState,
  getToolState,
} from "@cornerstonejs/tools/utilities/stackPrefetch/state";
import {
  getRenderingEngineLocal,
  makeBytesAvailableInCache,
} from "./CornerstoneService";
import hardcodedMetaDataProvider from "./MetadataProvider";
import { stackPrefetch } from "@cornerstonejs/tools/utilities";
import { isMobile } from "react-device-detect";
import { metaData } from "@cornerstonejs/core";
import { loadAndCacheImage } from "@cornerstonejs/core/loaders/imageLoader";

const RENDERING_ENGINE_ID = process.env.REACT_APP_RENDERING_ENGINE_ID;

export const prefetchData = async (index, onImageLoaded) => {
  const viewport = await getThumbnailViewport(index);
  if (!viewport) return;
  makeBytesAvailableInCache();
  stackPrefetch.enable(viewport.element);
};

export const stopPrefetchData = async (thumbnailIndex, onImageLoaded) => {
  const thumbnailViewport = await getThumbnailViewport(thumbnailIndex);
  stackPrefetch.disable(thumbnailViewport.element);
  const allThumbnailViewports = await getAllThumbnailViewports();
  allThumbnailViewports.map((viewport) => {
    let stackPrefetchData = getToolState(viewport.element);
    if (
      viewport.id !== "thumbnail_" + thumbnailIndex &&
      stackPrefetchData.enabled !== undefined &&
      stackPrefetchData.enabled === true
    ) {
      stackPrefetch.enable(viewport.element);
    }
  });
};

export const displayThumbnail = async (
  element,
  index,
  stack,
  stackSize,
  isPriors,
  priorStudyData,
  studyIndex,
  setThumbnailLoaded
) => {
  const thumbnailViewportInput = {
    viewportId: "thumbnail_" + index,
    type: ViewportType.STACK,
    element: element,
    imageIds: stack.imageIds,
  };

  cornerstone.metaData.addProvider(
    (type, imageId) => hardcodedMetaDataProvider(type, imageId, stack.imageIds),
    10000
  );
  const renderingEngine = await getRenderingEngineLocal(RENDERING_ENGINE_ID);
  renderingEngine.enableElement(thumbnailViewportInput);
  const thumbnailViewport = renderingEngine.getViewport(
    thumbnailViewportInput.viewportId
  );

  addToolState(element, stack);
  try {
    await thumbnailViewport.setStack(stack.imageIds, 0);
  } catch (error) {
    console.log(error);
  }
  thumbnailViewport.render();

  if (isMobile && index === 0) {
    setThumbnailLoaded(true);
    return;
  }

  if (!isPriors) {
    if (index === stackSize - 1) {
      // cornerstone.resetUseCPURendering();
      setThumbnailLoaded(true);
    }
  } else {
    if (priorStudyData.length - 1 === studyIndex) setThumbnailLoaded(true);
  }
};

export const getThumbnailViewport = async (index) => {
  const renderingEngine = await getRenderingEngineLocal(RENDERING_ENGINE_ID);
  const thumbnailViewport = renderingEngine.getViewport("thumbnail_" + index);
  return thumbnailViewport;
};

export const getAllThumbnailViewports = async () => {
  const renderingEngine = await getRenderingEngineLocal(RENDERING_ENGINE_ID);
  const thumbnailViewports = renderingEngine
    .getViewports()
    .filter((viewport) => viewport.id.startsWith("thumbnail"));
  return thumbnailViewports;
};

export const checkIfLateralSeries = async (thumbnailIndex) => {
  const thumbnailViewport = await getThumbnailViewport(thumbnailIndex);
  const imageId = await loadAndCacheImage(thumbnailViewport.imageIds[0]);
  const imagePlane = metaData.get("imagePlaneModule", imageId.imageId);
  if (imagePlane && imagePlane.rowCosines && imagePlane.columnCosines) {
    const row = [
      Math.round(imagePlane.rowCosines[0]),
      Math.round(imagePlane.rowCosines[1]),
      Math.round(imagePlane.rowCosines[2])
    ];
    const column = [
      Math.round(imagePlane.columnCosines[0]),
      Math.round(imagePlane.columnCosines[1]),
      Math.round(imagePlane.columnCosines[2])
    ];
    const normal = [];
    vec3.cross(normal, column, row);

    if (Math.abs(normal.x) === 1)
      return true;
  }
  return false;
};
